import { v4 as uuidv4 } from 'uuid';

const CLIENT_ID_KEY = 'sim_client_id';

// UUID anonimo persistente por navegador. Sirve para correlacionar
// distintas sesiones (thread_id) del mismo dispositivo en analitica.
// Se genera la primera vez y se reutiliza despues.
export function getClientId() {
    try {
        let id = window.localStorage.getItem(CLIENT_ID_KEY);
        if (!id) {
            id = uuidv4();
            window.localStorage.setItem(CLIENT_ID_KEY, id);
        }
        return id;
    } catch (_) {
        // Modo privado o storage bloqueado: devolvemos uno efimero.
        return uuidv4();
    }
}
